import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { VideoProfileValues } from 'src/app/core/settings/video-profile';

interface VideoProfileCellData extends VideoProfileValues {
  profileLabel: string;
  authoritativeEntityIds?: (string | undefined)[];
}

/**
 * Grid renderer for the collapsed "HD Video Profile - SF400" row. Shows the
 * matched profile badge and the four underlying Encoder/Source values grouped
 * together — the individual settings are hidden from the grid in favour of this.
 */
@Component({
  selector: 'video-profile-cell',
  templateUrl: './video-profile-cell.component.html',
  styleUrls: ['./video-profile-cell.component.scss'],
})
export class VideoProfileCellComponent implements ICellRendererAngularComp {
  profileLabel = '';
  encoderExterior = '';
  encoderInterior = '';
  sourceExterior = '';
  sourceInterior = '';
  clickable = false;
  /** True when the profile was modified at the entity being viewed (shows the pin). */
  pinned = false;

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  agInit(params: any): void {
    this.refresh(params);
  }

  refresh(params: any): boolean {
    // ag-Grid reuses renderer instances across rows, so always reset — otherwise a
    // row without profile data would show the previous row's stale values.
    const data: VideoProfileCellData | undefined = params.data?.videoProfile;
    this.profileLabel = data?.profileLabel ?? '';
    this.encoderExterior = data?.encoderExterior ?? '';
    this.encoderInterior = data?.encoderInterior ?? '';
    this.sourceExterior = data?.sourceExterior ?? '';
    this.sourceInterior = data?.sourceInterior ?? '';
    this.clickable = params.getIsClickable ? params.getIsClickable() : false;

    // Pin shows when the profile was modified at the entity being viewed — i.e.
    // any of the four underlying settings is authoritative at that entity
    // (mirrors ValueCellComponent's per-setting pin).
    const entityId = this.activatedRoute.snapshot.paramMap.get('selectedEntityId');
    this.pinned =
      !!entityId && !!data?.authoritativeEntityIds?.some((id) => id === entityId);
    return true;
  }
}
